import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, ShieldCheck, Zap, Lock } from 'lucide-react';
import { Button } from './ui/Button';
export function PricingSection() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 50
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          ...prev,
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-12 md:py-16 bg-slate-50" data-id="element-211">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-212">
        <div className="text-center mb-8" data-id="element-213">
          <div className="inline-flex items-center justify-center gap-2 text-red-600 font-bold text-sm mb-2" data-id="element-214">
            <Clock className="w-4 h-4" data-id="element-215" />
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>
          <div className="text-3xl font-bold font-heading text-navy mb-2" data-id="element-216">
            {String(timeLeft.h).padStart(2, '0')}
            <span className="text-slate-400 mx-1" data-id="element-217">:</span>
            {String(timeLeft.m).padStart(2, '0')}
            <span className="text-slate-400 mx-1" data-id="element-218">:</span>
            {String(timeLeft.s).padStart(2, '0')}
          </div>
          <div className="text-sm text-slate-500 mb-6" data-id="element-219">
            ⚠️ Después sube $10.000 ARS. No vuelve.
          </div>

          <h2 className="text-3xl font-bold text-navy mb-4" data-id="element-220">
            ELEGÍ TU SISTEMA
          </h2>

          <div className="max-w-xs mx-auto text-left" data-id="element-221">
            <div className="flex justify-between text-xs font-bold text-slate-500 mb-1" data-id="element-222">
              <span data-id="element-223">Cupos al precio de lanzamiento</span>
              <span data-id="element-224">72%</span>
            </div>
            <div className="h-2 bg-slate-200 rounded-full overflow-hidden" data-id="element-225">
              <motion.div initial={{
              width: 0
            }} animate={{
              width: '72%'
            }} transition={{
              duration: 1
            }} className="h-full bg-gold rounded-full" data-id="element-226" />
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 items-start" data-id="element-227">
          {/* Base */}
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200" data-id="element-228">
            <h3 className="text-xl font-bold text-navy mb-1" data-id="element-229">
              📘 Mis Primeras Lecturas (plan base)
            </h3>
            <p className="text-sm text-slate-500 mb-4" data-id="element-230">5 Tomos + 3 Bonos</p>
            <p className="text-sm text-slate-600 mb-6" data-id="element-231">
              Ideal para comenzar correctamente el proceso lector.
            </p>

            <div className="flex items-baseline gap-2 mb-6" data-id="element-232">
              <span className="text-slate-400 line-through text-sm" data-id="element-233">
                $39.990
              </span>
              <span className="text-3xl font-bold text-navy" data-id="element-234">
                $14.990 <span className="text-sm font-normal" data-id="element-235">ARS</span>
              </span>
            </div>

            <Button variant="primary" className="w-full bg-blue-600 hover:bg-blue-700" href="https://www.tupuntodigital.shop/cart/46116455907501:1" data-id="element-236">
              QUIERO EL PLAN BASE
            </Button>
          </div>

          {/* Premium */}
          <div className="bg-white text-navy rounded-2xl p-6 shadow-xl relative border border-gold/40" data-id="element-237">
            <div className="absolute -top-3 left-6 bg-gold text-navy text-xs font-bold px-3 py-1 rounded-full" data-id="element-238">
              ⭐ El más elegido
            </div>
            <h3 className="text-xl font-bold text-gold-600 mb-1 mt-2" data-id="element-239">
              🏆 Mis Primeras Lecturas + Kit Acelerador
            </h3>
            <p className="text-sm text-slate-500 mb-4" data-id="element-240">
              5 Tomos + 3 Bonos + Kit Acelerador Completo
            </p>
            <p className="text-sm text-slate-600 mb-6" data-id="element-241">
              Tarjetas Extra, Juegos de Lectura, Mini Lecturas, Desafíos de 21
              Días.
            </p>

            <div className="flex items-baseline gap-2 mb-6" data-id="element-242">
              <span className="text-slate-400 line-through text-sm" data-id="element-243">
                $59.990
              </span>
              <span className="text-4xl font-bold text-navy" data-id="element-244">$22.990</span>
            </div>

            <Button variant="gold" className="w-full" href="https://www.tupuntodigital.shop/cart/46116456104109:1" data-id="element-245">
              QUIERO EL PREMIUM
            </Button>
          </div>
        </div>

        <div className="flex justify-center gap-4 mt-8 text-xs text-slate-500 font-medium" data-id="element-246">
          <div className="flex items-center" data-id="element-247">
            <ShieldCheck className="w-3 h-3 mr-1" data-id="element-248" /> Garantía 7 días
          </div>
          <div className="flex items-center" data-id="element-249">
            <Zap className="w-3 h-3 mr-1" data-id="element-250" /> Acceso inmediato
          </div>
          <div className="flex items-center" data-id="element-251">
            <Lock className="w-3 h-3 mr-1" data-id="element-252" /> Pago seguro
          </div>
        </div>
      </div>
    </section>;
}